import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: calc(100vh);
  display: flex;
  & > div {
    flex: 1;
  }
`;

const LoggedOutApp = ({children}) => (
  <Wrapper>
    {children}
  </Wrapper>
);
LoggedOutApp.propTypes = {
  children: PropTypes.object.isRequired
};

export default LoggedOutApp;



// WEBPACK FOOTER //
// ./src/pages/LoggedOutApp.js